import { Button, Notification } from "@stellar/design-system";

import "../styles.scss";

type UnenrollmentWarningProps = {
  isContinuing?: boolean;
  canContinue?: boolean;
  error?: string | null;
  onBack: () => void;
  onCancel: () => void;
  onContinue: () => void;
};

export const UnenrollmentWarning = ({
  isContinuing,
  canContinue = true,
  error,
  onBack,
  onCancel,
  onContinue,
}: UnenrollmentWarningProps) => (
  <div className="MultisigManage">
    <div className="MultisigManage__wiz">
      {error ? (
        <div className="MultisigManage__error">
          <Notification variant="error" title="Couldn't turn off co-signing" isFilled>
            {error}
          </Notification>
        </div>
      ) : null}
      <div className="MultisigManage__card MultisigManage__card--wizard">
        <h2 className="MultisigManage__title">Turn off co-signing?</h2>
        <p className="MultisigManage__p">
          Turning off co-signing needs two Owners. You&apos;ll sign first, then another Owner signs
          before anything changes. If another Owner doesn&apos;t sign within 4 days, the request
          expires and everything goes back to how it was.
        </p>
        <h3 className="MultisigManage__sub MultisigManage__sub--list">
          As soon as you continue, a co-signing pause starts
        </h3>
        <ul className="MultisigManage__list MultisigManage__list--wizard">
          <li>New disbursements can&apos;t be created.</li>
          <li>Disbursements waiting for signatures can&apos;t collect any more signatures.</li>
          <li>Co-signers can&apos;t be added or removed.</li>
        </ul>
        <h3 className="MultisigManage__sub MultisigManage__sub--list">Once a second Owner signs</h3>
        <ul className="MultisigManage__list MultisigManage__list--wizard">
          <li>
            Disbursements waiting for signatures are canceled and returned to drafts. Any signatures
            already collected are discarded, and whoever created them is notified.
          </li>
          <li>
            Co-signers are removed. Their keys stay in VIA Wallet but stop working here. If you turn
            co-signing back on later, they can use the same keys again.
          </li>
        </ul>
        <div className="MultisigManage__actions">
          <Button variant="tertiary" size="md" disabled={isContinuing} onClick={onBack}>
            ‹ Back
          </Button>
          <div className="MultisigManage__actionsRight">
            <Button variant="tertiary" size="md" disabled={isContinuing} onClick={onCancel}>
              Keep co-signing on
            </Button>
            <Button
              variant="destructive"
              size="md"
              isLoading={isContinuing}
              disabled={!canContinue}
              onClick={onContinue}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
);
